import React, { useEffect } from 'react';

const DoubleDonation = () => {
  useEffect(() => {
    const script1 = document.createElement('script');
    script1.innerHTML = `var DDCONF = { API_KEY: "MBaEr72Scd6opwMH" };`;
    document.head.appendChild(script1);

    // Cleanup on component unmount
    return () => {
      document.head.removeChild(script1);
    };
  }, []);
  return (
    <>
      <div id='dd-container'>
        <a href='https://doublethedonation.com/matching-grant-resources/matching-gift-basics/'>
          Matching Gift{' '}
        </a>
        and{' '}
        <a href='https://doublethedonation.com/matching-grant-resources/volunteer-grant-basics/'>
          Volunteer Grant{' '}
        </a>
        information provided by{' '}
        <a href='https://doublethedonation.com'>
          <img
            src='https://doublethedonation.com/api/img/powered-by.png'
            alt='Powered by Double the Donation'
          />
        </a>
      </div>
    </>
  );
};

export default DoubleDonation;
